import angular from 'angular';

import { UserEditionController } from './user-edition.controller';
import { AssignUserController } from './assign-user.controller';
import { RoleEditionController } from './role-edition.controller';
import { TeamEditionController } from './team-edition.controller';
import { UsersRolesService } from './users-roles.service.js';


angular
  .module('users-roles', [])
  .controller('UserEditionController', UserEditionController)
  .controller('AssignUserController', AssignUserController)
  .controller('RoleEditionController', RoleEditionController)
  .controller('TeamEditionController', TeamEditionController)
  .factory('UsersRolesFactory', UsersRolesService.UsersRolesFactory)
  ;